import { Controller } from '@hotwired/stimulus';
import { words } from '../lib/ago';

// A <time datetime="…"> that stays true on an open page (LayoutHelper#ago).
// The server draws the first words; this redraws them on the same ladder.
//
//   <time datetime="2026-10-12T12:00:00Z" data-controller="ago"
//         data-ago-since-value="true">há 2 min</time>
export default class extends Controller {
  static values = { since: { type: Boolean, default: true }, every: { type: Number, default: 30000 } };

  connect() {
    this.draw();
    this.timer = setInterval(() => this.draw(), this.everyValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  draw() {
    const at = Date.parse(this.element.getAttribute('datetime'));
    if (Number.isNaN(at)) return;

    this.element.textContent = words((Date.now() - at) / 1000, this.sinceValue);
  }
}
